import React,{ forwardRef } from 'react';
import { ResponsiveFunnel } from '@nivo/funnel';
import { Box } from '@mui/material';

interface FunnelDataItem {
    id: string;
    label: string;
    value: number;
}

interface FunnelChartProps {
    data: FunnelDataItem[];
    height?: string | number;
    colors?: { scheme: string };
    interpolation?: 'smooth' | 'linear';
    spacing?: number;
    shapeBlending?: number;
}

export const FunnelChart = forwardRef<HTMLDivElement, FunnelChartProps>(
    (
        {
            data,
            height = '100%',
            colors = { scheme: 'nivo' },
            interpolation = 'smooth',
            spacing = 0,
            shapeBlending = 0.66,
        },
        ref
    ) => {
        return (
            <Box ref={ref} sx={{ height, width: '100%' }}>
                <ResponsiveFunnel
                    data={data}
                    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                    valueFormat=">-.4s"
                    colors={colors}
                    borderWidth={20}
                    labelColor={{ from: 'color', modifiers: [['darker', 3]] }}
                    beforeSeparatorLength={100}
                    beforeSeparatorOffset={20}
                    afterSeparatorLength={100}
                    afterSeparatorOffset={20}
                    currentPartSizeExtension={10}
                    currentBorderWidth={40}
                    motionConfig="wobbly"
                    interpolation={interpolation}
                    spacing={spacing}
                    shapeBlending={shapeBlending}
                />
            </Box>
        );
    }
);

FunnelChart.displayName = 'FunnelChart';
